import { CiSiteRule } from './ci-site-rule.constant';
import { CookstoveRule } from './cookstove-rule.constant';
import { MeshgridRule } from './meshgrid-rule.constant';
import { MinigridRule } from './minigrid-rule.constant';
import { CreditRule } from './credit-rule.constant';
import { PueRule } from './pue-rule.constant';
import { ShsRule } from './shs-rule.constant';
import { DigitalDeviceRule } from './digital-device.constant';

export const PROJECT_SPECIFICATION_FORM_RULES = {
  CI_SITE: CiSiteRule.rule(),
  COOKSTOVE: CookstoveRule.rule(),
  CREDIT: CreditRule.rule(),
  MESHGRID: MeshgridRule.rule(),
  MINIGRID: MinigridRule.rule(),
  PRODUCTIVE_USE_EQUIPMENT: PueRule.rule(),
  SOLAR_HOME_SYSTEM: ShsRule.rule(),
  DIGITAL_DEVICE: DigitalDeviceRule.rule()
};
